import React from "react";
import { race17CardImg } from "../../diamondCasinoAllGames/race17/race17Cards";

/**
 * Race to 17 result body — reference markup:
 * .row.row5.worli-result > .col-12.col-lg-7 (dealt cards, backs "1" skipped)
 *                        + .col-12.col-lg-5 > .casino-result-desc (rdesc "race17#bigcard#zerocard#onezero").
 */
export default function Race17ResultBody({ t1 }) {
  const cards = t1?.card ? String(t1.card).split(",") : [];
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const labels = ["Race to 17", "Big Card", "Zero Card", "One Zero Card"];

  return (
    <div className="row row5 worli-result">
      {cards.length > 0 && (
        <div className="col-12 col-lg-7">
          <div className="casino-result-content">
            <div className="casino-result-content-item text-center w-100">
              <div className="casino-result-cards">
                {cards.map((c, i) =>
                  c !== "1" ? (
                    <div key={i} className="casino-result-cards-item mr-1">
                      <img src={race17CardImg(c)} alt="" />
                    </div>
                  ) : null
                )}
              </div>
            </div>
          </div>
        </div>
      )}{" "}
      <div className="col-12 col-lg-5">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            {labels.map((label, i) => (
              <React.Fragment key={label}>
                {i > 0 && " "}
                <div className="casino-result-desc-item">
                  <div>{label}</div> <div>{desc[i]}</div>
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
